import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [!_vm.hasOutboundConnectors ? _c('core-n20-card', {
    staticClass: "dt-card-text-01 payload"
  }, [_c(VAlert, {
    staticClass: "mb-1",
    staticStyle: {
      "padding-left": "0px",
      "padding-top": "5px"
    },
    attrs: {
      "value": true,
      "color": "transparent",
      "icon": "fal fa-exclamation-circle"
    }
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.noConnectorAvailable')) + "\n      ")])]), _vm._v("\n    " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.forwardData')) + "\n  ")], 1) : _c('div', [_c(VAlert, {
    attrs: {
      "value": true,
      "color": "#c0e4f6"
    }
  }, [_c('i', {
    staticClass: "fal fa-exclamation-circle fa-lg",
    attrs: {
      "value": true,
      "aria-hidden": "true"
    }
  }), _vm._v("\n       \n      "), _c('span', [_vm._v("\n        " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.integrateExportedData')) + "\n      ")]), _c('br'), _c('br'), _c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.forwardDownloadLink')) + "\n      ")])]), _c('span', [_vm._v(_vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.selectConnector')))]), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "disabled": !_vm.hasOutboundConnectors,
      "label": _vm.$i18n_t('accMgmt.tenant.bridges.types'),
      "items": _vm.outboundConnectors,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "return-object": "",
      "readonly": _vm.readonly
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemAvatar, [_c(VAvatar, {
          attrs: {
            "size": "32"
          }
        }, [_vm.bridgeTypesIcons[data.item.type] ? _c('img', {
          attrs: {
            "src": _vm.bridgeTypesIcons[data.item.type],
            "alt": data.item.name,
            "title": data.item.name
          }
        }) : _vm._e()])], 1), _c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        }), _c(VListItemSubtitle, [_vm._v("\n                " + _vm._s(data.item.type.replace('bridge-', '')) + " (ID " + _vm._s(data.item.id) + ")\n              ")])], 1)];
      }
    }]),
    model: {
      value: _vm.internalModel.selectedOutboundConnector,
      callback: function ($$v) {
        _vm.$set(_vm.internalModel, "selectedOutboundConnector", $$v);
      },
      expression: "internalModel.selectedOutboundConnector"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "8"
    }
  }, [_c(VTextarea, {
    attrs: {
      "label": 'Payload',
      "rows": "5",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "autocomplete": "off",
      "rules": _vm.validJson,
      "clearable": !_vm.readonly,
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.internalModel.payload,
      callback: function ($$v) {
        _vm.$set(_vm.internalModel, "payload", $$v);
      },
      expression: "internalModel.payload"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };